import { ModelData, ModelList } from "@shared/models/prompt-settings.model";
import { GPTModel } from "@shared/models/gpt-models/gpt-models";
import { featureFlags } from "@app/environments/environment";

export const imageSize = [
  { title: 'Square', description: '1024x1024', value: "1024x1024" },
  { title: 'Portrait', description: '1024x1792', value: "1024x1792" },
  { title: 'Landscape', description: '1792x1024', value: "1792x1024" }
];

export const imageQuality = [
  { title: 'High definition (HD)', description: 'Finer details, greater consistency, longer image creation.', value: "hd" },
  { title: 'Standard', description: 'Quick and simple image creation.', value: "standard" }
];

export const imageStyle = [
  { title: 'Natural', description: 'Real natural-looking style.', value: "natural" },
  { title: 'Vivid', description: 'Hyper-real and dramatic images.', value: "vivid" },
];

const modelList: ModelList = [
  {
    model: "gpt-4-o",
    name: "GPT-4o",
    description: "Comprehensive, high-performance, and fast for extensive and large-scale tasks.",
    integrations: ["text", "image", "spreadsheets"],
    status: "available"
  } as ModelData,
  {
    model: "claude-3-5-sonnet",
    name: "Claude 3.5 Sonnet",
    description: "Improved reasoning, natural language writing and code generation.",
    integrations: ["text", "image", "spreadsheets"],
    status: "beta"
  } as ModelData,
  {
    model: "claude-3-7-sonnet",
    name: "Claude 3.7 Sonnet",
    description: "A hybrid reasoning model with complex problem-solving, coding, and creative writing capabilities.",
    integrations: ["text", "image", "spreadsheets"],
    status: "beta"
  } as ModelData,
];

export function getModelList(): ModelList {
  return modelList.filter(model => switchClaudeSonnetVersion(model));
}

function switchClaudeSonnetVersion(model: ModelData): boolean {
  const excludedModel = featureFlags.enableClaude ? 'claude-3-5-sonnet' : 'claude-3-7-sonnet';
  return model.model !== excludedModel;
}

export const modelMap = new Map<GPTModel, ModelData>(
  modelList.map(model => [model.model, model])
);
